import gql from 'graphql-tag';

export const FORGOT_PASSWORD_SUPER_ADMIN = gql`
  mutation ForgotPassword($input: ForgotPasswordInput!) {
    forgotPassword(input: $input) {
      success
      error
      resetPasswordToken
    }
  }
`;
